import { QueryEntityModel } from 'Core/Controls/Grid/Models/GridDataModel/QueryExpression/QueryEntityModel';
import { FieldMetadataModel } from 'Core/Controls/Grid/Models/GridDataModel/FieldMetadataModel';
import enumerable from 'Core/Common/Decorators/EnumerableDecorator';

export class PrimaryKeyField {
	private _queryEntity: QueryEntityModel;
	private _fieldMetadata: FieldMetadataModel;

	constructor(queryEntity: QueryEntityModel, fieldMetadata: FieldMetadataModel) {
		this._queryEntity = queryEntity;
		this._fieldMetadata = fieldMetadata;
	}

	@enumerable get Title(): string {
		var entityName = this._queryEntity.Metadata.NameTranslation || this._queryEntity.Metadata.Name;

		if (this._queryEntity.Index > 1) {
			entityName = `${entityName}${this._queryEntity.Index}`;
		}

		return `${entityName}.${this._fieldMetadata.NameTranslation || this._fieldMetadata.Name}`;
	}

	@enumerable get FieldMetadata() {
		return this._fieldMetadata;
	}

	@enumerable get EntityMetadata() {
		return this._queryEntity.Metadata;
	}

	@enumerable get QueryEntityGuid() {
		return this._queryEntity.Guid;
	}
}